"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var createMuiTheme_1 = require("@material-ui/core/styles/createMuiTheme");

var breakpoints_1 = require("./breakpoints");

var components_1 = require("./components");

var direction_1 = require("./direction");

var mixins_1 = require("./mixins");

var palette_1 = require("./palette");

var shadows_1 = require("./shadows");

var shape_1 = require("./shape");

var spacing_1 = require("./spacing");

var transitions_1 = require("./transitions");

var typography_1 = require("./typography");

var zIndex_1 = require("./zIndex");
/**
 * See:
 * https://material-ui.com/customization/default-theme
 * for defaults built into material-ui
 */


var theme = {
  breakpoints: breakpoints_1["default"],
  direction: direction_1["default"],
  mixins: mixins_1["default"],
  overrides: components_1.overrides,
  palette: palette_1["default"],
  props: components_1.props,
  shape: shape_1["default"],
  shadows: shadows_1["default"],
  spacing: spacing_1["default"],
  transitions: transitions_1["default"],
  typography: typography_1["default"],
  zIndex: zIndex_1["default"]
};
exports["default"] = createMuiTheme_1["default"](theme);